import { useQuery } from "@tanstack/react-query";
import { getEprescriptions } from "../services/ePrescriptionService";

export const useEprescriptions = (
  userId?: number,
  token?: string | null
) => {
  return useQuery({
    queryKey: ["eprescriptions", userId],
    queryFn: () => getEprescriptions(userId!, token!),

    enabled: !!userId && !!token,

    staleTime: 0,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};